import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
var _excluded = ["filterState"];
import "core-js/modules/es6.object.keys.js";
import React from 'react';
import PropTypes from 'prop-types';
import parseAttributes from 'parse-attributes';
import decamelize from 'decamelize'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import mapKeys from 'lodash/mapKeys'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import pick from 'lodash/pick'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import toString from 'lodash/toString';
import { CCProductImpression, ProductImpression } from '@nerdwallet/nw-client-lib/tracking';
export var prepLinkData = function prepLinkData(linkData) {
  if (_typeof(linkData) === 'object') {
    return linkData;
  } // Input: "dataOne='uno' dataTwo='dos'"
  // Output {"data-one": "uno", "data-two": "dos"}


  var attrs = parseAttributes(linkData);
  return mapKeys(attrs, function (value, key) {
    return decamelize(key, '-');
  });
};
export var getCCImpressionProps = function getCCImpressionProps(_ref) {
  var filterState = _ref.filterState,
      props = _objectWithoutProperties(_ref, _excluded);

  var linkData = prepLinkData(props.link_data);
  var impressionProps = {
    id: toString(props.id),
    issuer: props.issuer,
    pageNumber: props.pageNumber,
    productPosition: props.productPosition,
    productLocation: props.productLocation,
    productInstance: props.productInstance,
    sectionPosition: props.sectionPosition,
    productId: toString(props.productId || linkData['data-cid']),
    productSlug: props.productSlug || linkData['data-cname'],
    linkType: props.linkType || linkData['data-link-type'],
    offerVersionId: toString(props.offerVersionId || linkData['data-offer-version-id'])
  };

  if (filterState) {
    impressionProps.cardNetworkFilter = filterState.cardNetworkFilter;
    impressionProps.creditScoreFilter = filterState.creditScoreFilter;
    impressionProps.feesFilter = filterState.feesFilter;
    impressionProps.financialInstitutionsFilter = filterState.financialInstitutionsFilter;
    impressionProps.monthlySpendFilter = filterState.monthlySpendFilter;
    impressionProps.yearsWithCardFilter = filterState.yearsWithCardFilter;
  }

  return impressionProps;
};

var getProductImpressionProps = function getProductImpressionProps(props) {
  return _objectSpread(_objectSpread({}, pick(props, Object.keys(ProductImpression.propTypes))), {}, {
    id: toString(props.id),
    productId: toString(props.productId)
  });
};

var ApplyNowImpression = function ApplyNowImpression() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // Allow consumer to opt out of logging impression, particularly useful for testing as the impression is a container component
  if (!props.logImpression) {
    return props.children;
  }

  return props.isCC ? /*#__PURE__*/React.createElement(CCProductImpression, getCCImpressionProps(props), props.children) : /*#__PURE__*/React.createElement(ProductImpression, getProductImpressionProps(props), props.children);
};

ApplyNowImpression.displayName = 'ApplyNowImpression';
ApplyNowImpression.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  // Unique id for the impression on this page
  isCC: PropTypes.bool,
  link_data: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  issuer: PropTypes.string,
  filterState: PropTypes.shape({
    // The filter state is captured in impressions on the credit card tool
    cardNetworkFilter: PropTypes.string,
    creditScoreFilter: PropTypes.string,
    feesFilter: PropTypes.string,
    financialInstitutionsFilter: PropTypes.string,
    monthlySpendFilter: PropTypes.number,
    yearsWithCardFilter: PropTypes.number
  }),
  pageNumber: PropTypes.number,
  productPosition: PropTypes.number,
  productLocation: PropTypes.string,
  productInstance: PropTypes.string,
  sectionPosition: PropTypes.number,
  offerVersionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  productSlug: PropTypes.string,
  linkType: PropTypes.string,
  logImpression: PropTypes.bool,
  children: PropTypes.element.isRequired
};
export default ApplyNowImpression;